export default __webpack_public_path__ + "static/ic_logo_dark-ce6615a8452cc25b72957c2145dcf72f.svg";